import CustomersModal from './CustomersModal'

export default CustomersModal